module.exports = __webpack_public_path__ + "img/account-summary-history-white.c5a36838.svg";